import React, { useState } from "react";

import Content from "./Content";
import { WalletContext } from "../../../../../CustomHelper/Helper";
import Packages from "../../../../../Screen/Packages/Packages";

const WalletBody = (props) => {
  const [allPackages, setAllPackage] = useState([]);
  const [loveBundel, setLoveBundel] = useState([]);
  const [userWalletHistory, setUserWalletHistory] = useState([]);
  const [packageId, setPackageId] = useState("");
  const [userId, setUserId] = useState("");

  const [userWallet, setGetUserWallet] = useState();
  const [userWalletId, setGetUserWalletId] = useState();
  const [lastUserWalletHistory, setLastUserWalletHistory] = useState();

  const [checkRealTime, setCheckRealTime] = useState(false);



  return (
    <>
      <WalletContext.Provider
        value={{
          allPackages,
          loveBundel,
          setLoveBundel,
          setAllPackage,
          userWalletHistory,
          setUserWalletHistory,
          packageId,
          setPackageId,
          userId,
          setUserId,
          userWallet,
          setGetUserWallet,
          userWalletId,
          setGetUserWalletId,
          lastUserWalletHistory,
          setLastUserWalletHistory,
          checkRealTime,
          setCheckRealTime,
        }}
      >
        <Content />
        <Packages />
      </WalletContext.Provider>
    </>
  );
};

export default WalletBody;
